import { ViewContext } from '../../enums';

const InputFieldAccessGrants = ({
  // DEPENDENCIES
  client,
  context,
  employee,
  hasAppointmentGrouping,
  isEditMode,
  isEmployeePerspective,
  isProjectAppointment,
  isRecurring,
  isRecurringChecked,
  isVV,
  isWorkPlaceAppointment,
  linkedEmployee,
  periodType
}: // ^
{
  [key: string]: any;
}) => {
  const isTeamContext = context === ViewContext.Team;
  const hasEmployee = !!(employee || linkedEmployee);
  const whoIsEditable = (isVV || isProjectAppointment) && isTeamContext;

  return {
    ACTIVITY_SELECT: [
      isProjectAppointment,
      isWorkPlaceAppointment,
      isVV && !isEditMode
    ],
    CLIENT: [!isProjectAppointment && !whoIsEditable, isVV && !isEditMode],
    CLIENT_AVATAR: [!!client],
    CLIENT_PREVIEW: [!!client && whoIsEditable && isEditMode],
    DAY_IN_WEEK_SET: [
      !isWorkPlaceAppointment && !isProjectAppointment && !isEditMode
    ],
    NOTE_INTERNAL: [
      !isEditMode,
      isWorkPlaceAppointment,
      isProjectAppointment,
      isVV
    ],
    EMPLOYEE: [
      isProjectAppointment,
      isWorkPlaceAppointment && isEditMode && !!employee
    ],
    EMPLOYEE_AVATAR: [
      isProjectAppointment && !!employee,
      isWorkPlaceAppointment && isEditMode && !!employee,
      isVV && hasEmployee
    ],
    EMPLOYEE_PREVIEW: [
      isVV && isEditMode && hasEmployee && !isEmployeePerspective,
      isVV &&
        isEditMode &&
        hasEmployee &&
        isEmployeePerspective &&
        hasAppointmentGrouping
    ],
    EMPLOYEE_TYPE_SELECT: [isVV],
    EMPLOYMENT: [
      isVV && isEditMode && isEmployeePerspective && !hasAppointmentGrouping
    ],
    APPOINTMENT_GROUPING_PREVIEW: [isEditMode && hasAppointmentGrouping],
    END_TIME: [!isProjectAppointment],
    EXTRA: [
      !isEditMode,
      isWorkPlaceAppointment,
      isProjectAppointment,
      isVV,
      !isWorkPlaceAppointment && !!client,
      !isProjectAppointment && !!client
    ],
    LOCATION_TYPE: [
      !isWorkPlaceAppointment && !isProjectAppointment && !!client
    ],
    PERIOD_TYPE: [
      !isWorkPlaceAppointment &&
        !isProjectAppointment &&
        !isEditMode &&
        !!isRecurringChecked
    ],
    PROJECT_ENTITY_ID: [],
    PROJECT_SELECT: [isProjectAppointment],
    RECURRENCE_RULE_EDIT: [
      !isWorkPlaceAppointment && !isProjectAppointment && !isEditMode
    ],
    RECURRENCE_RULE_VIEW: [
      isRecurring &&
        !isWorkPlaceAppointment &&
        !isProjectAppointment &&
        isEditMode
    ],
    START_DATE_FULL_WIDTH: [isProjectAppointment],
    START_DATE_VALIDATION: [isProjectAppointment || isWorkPlaceAppointment],
    START_TIME: [!isProjectAppointment],
    WEEK_DAYS: [periodType === 'WEEK' && !!isRecurringChecked],
    WHAT: [],
    WHAT_IS_EDITABLE: [
      isWorkPlaceAppointment,
      isProjectAppointment,
      isVV,
      !isEditMode
    ],
    WHERE: [!isProjectAppointment],
    WHERE_IS_EDITABLE: [!isProjectAppointment],
    WHICH: [
      isRecurring &&
        (!isWorkPlaceAppointment || isProjectAppointment) &&
        isEditMode
    ],
    WHO: [
      isProjectAppointment,
      !isWorkPlaceAppointment && (!isEditMode || !!client),
      isWorkPlaceAppointment && isEditMode && !!employee
    ],
    WHO_IS_EDITABLE: [whoIsEditable],
    WHO_IS_PREVIEW: [isEditMode, !isTeamContext],
    WORKPLACE_ENTITY_ID: [isWorkPlaceAppointment],
    WORKPLACE_SELECT: [isWorkPlaceAppointment]
  };
};

export type FieldKey = keyof ReturnType<typeof InputFieldAccessGrants>;
const fieldGrants = (deps: {
  [key: string]: any;
}): ((key: FieldKey) => boolean) => {
  return (key: FieldKey) =>
    (InputFieldAccessGrants(deps)[key] as boolean[]).includes(true);
};

export { fieldGrants };
